import { useEffect, useState } from "react";
import { TProcessStates } from "../../../../lib/types/general";
import {
    getPaymentRecords as _getPaymentRecords,
    getAllSubscriptions as _getAllSubscriptions,
    retryPayment as _retryPayment,
    editCreditsApi as _editCreditsApi,
    TPaymentRow,
    TSubscriptionRow,
    TSubscriptionFilterProps,
} from "../../../../services/backoffice/backoffice-service";
import { useAuthContext } from "../../../../contexts/auth-context";

export const useFinanceServices = () => {
    const [workingState, setWorkingState] = useState<TProcessStates>("idle");
    const { getUserTokenId } = useAuthContext();
    const [paymentList, setPaymentList] = useState<TPaymentRow[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const getAllPaymentRecords = async (offset: number) => {
        setWorkingState("working");
        const userTokenId = await getUserTokenId();
        const _response = await _getPaymentRecords(offset, userTokenId);
        setPaymentList(_response.data.data.records);
        setTotalRows(_response.data.data.totalRecordsCount);
        setWorkingState("done");
    };

    const retryPaymentIntent = async (user_id: number) => {
        const userTokenId = await getUserTokenId();
        return _retryPayment(user_id, userTokenId);
    };

    useEffect(() => {
        getAllPaymentRecords(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        paymentList,
        workingState,
        totalRows,
        currentPage,
        getAllPaymentRecords,
        retryPaymentIntent,
        setCurrentPage,
    };
};

export const useSubscriptionServices = () => {
    const [workingState, setWorkingState] = useState<TProcessStates>("idle");
    const { getUserTokenId } = useAuthContext();
    const [subscriptionList, setSubscriptionList] = useState<
        TSubscriptionRow[]
    >([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const props: TSubscriptionFilterProps = { enabled: "all", name: "" };

    const getAllSubscriptions = async (
        offset: number,
        filterProps: TSubscriptionFilterProps
    ) => {
        setWorkingState("working");
        const userTokenId = await getUserTokenId();
        const _response = await _getAllSubscriptions(
            offset,
            userTokenId,
            filterProps
        );
        setSubscriptionList(_response.data.data.subscriptionsData);
        setTotalRows(_response.data.data.totalSubscriptionsCount);
        setWorkingState("done");
    };

    const editCredits = async (userid: number, credits: number) => {
        const userTokenId = await getUserTokenId();
        return _editCreditsApi(userTokenId, userid, credits);
    };

    useEffect(() => {
        getAllSubscriptions(0, props);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        subscriptionList,
        workingState,
        totalRows,
        currentPage,
        getAllSubscriptions,
        editCredits,
        setCurrentPage,
    };
};
